import { ArrowDown, ArrowUpRight, Phone } from "lucide-react";
import { useEffect, useState } from "react";

export function HeroSection({ copy, content, language, onQuote }) {
  const [scrollY, setScrollY] = useState(0);
  const lines = language === "en" ? content.hero_lines_en : content.hero_lines_es;
  const body = language === "en" ? content.hero_body_en : content.hero_body_es;
  const eyebrow = language === "en" ? content.hero_eyebrow_en : content.hero_eyebrow_es;

  useEffect(() => {
    const update = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, []);

  return (
    <section className="hero-section" data-testid="hero-section">
      <div className="hero-grid page-width">
        <div className="hero-copy">
          <p className="eyebrow hero-eyebrow">{eyebrow}</p>
          <div className="hero-heading" data-testid="hero-kinetic-headline">
            {lines.map((line, index) => <div className="kinetic-line-wrap" key={`${line}-${index}`}><span className="kinetic-line" style={{ animationDelay: `${index * 0.14}s` }}>{line}</span></div>)}
          </div>
          <p className="hero-body">{body}</p>
          <div className="hero-actions">
            <button className="button button--accent" type="button" onClick={onQuote} data-testid="hero-estimate-cta">{copy.hero.cta}<ArrowUpRight size={17} /></button>
            <a className="text-link text-link--light" href={`tel:${content.phone_primary.replaceAll("-", "")}`} data-testid="hero-phone-link"><Phone size={16} /> {copy.hero.call}</a>
          </div>
          <div className="hero-phones" aria-label="Phone numbers">
            <a href={`tel:${content.phone_primary.replaceAll("-", "")}`} data-testid="hero-phone-primary">{content.phone_primary}</a>
            <span>·</span>
            <a href={`tel:${content.phone_secondary.replaceAll("-", "")}`} data-testid="hero-phone-secondary">{content.phone_secondary}</a>
          </div>
          <div className="hero-location"><span className="status-dot" />{copy.hero.serviceArea}</div>
        </div>
        <figure className="hero-visual" data-testid="hero-visual">
          <div className="hero-logo-stage" style={{ transform: `translate3d(0, ${Math.min(scrollY * 0.08, 34)}px, 0)` }}>
            <img src={content.logo_url} alt={`${content.company_name} brand mark`} data-testid="hero-brand-logo" />
            <span className="hero-stamp">MN / EST. TREE WORK</span>
          </div>
          <figcaption><span>{copy.hero.mark}</span><span>01 — 04</span></figcaption>
        </figure>
      </div>
      <a href="#services" className="scroll-cue" data-testid="hero-scroll-cue"><span>{language === "en" ? "Scroll the work" : "Ver el trabajo"}</span><ArrowDown size={16} /></a>
    </section>
  );
}
